export default __webpack_public_path__ + "static/media/ico-predefinido.701595f7.svg";